import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { spacing } from '../../../../gin-and-tonic/foundation/spacing'

const styles = css({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridRowGap: spacing.X16,
})

export const ContractorPortalRoot: FunctionComponent = () => <div css={styles}></div>
